<div class="event-box-header">Aperçu rendez-vous</div>

<div class="event-box-content" *ngIf="event">
    <div class="event-box-infos">
        <div class="infos-patient" *ngIf="event.patient">
            <span class="image patient-img"></span>
            <span class="patient-infos">
                <div class="patient-name">{{ event.patient.nom }} {{ event.patient.prenom }}</div>
                <div class="patient-birth">({{ event.patient.dateNaissance }})</div>
            </span>
        </div>
        <div class="infos-rdv">
            <span class="image rdv-img"></span>
            <span class="rdv-infos">
                <div class="rdv-hour">{{ event.dateDebut | date:"HH:mm" }} - {{ event.dateFin | date:"HH:mm" }}</div>
                <div class="rdv-date">{{ event.dateDebut | date:"EEEE d MMMM" }}</div>
            </span>
        </div>
    </div>

    <div class="event-box-type" *ngIf="event.type && event.type.label !== ''">
        <span class="type-label">{{ event.type.label }}</span>
        <span #typeColor class="type-color"></span>
    </div>

    <div class="event-box-description" *ngIf="event.description">Description : {{ event.description }}</div>

    <!-- <div class="event-box-rappels" *ngIf="event.rappel && event.rappel.length > 0">
        <div class="event-box-rappel" *ngFor="let rappel of event.rappel">
            <span class="rappel-alert"></span>
            <span class="rappel-label">{{ rappel }}</span>
        </div>
    </div> -->

    <!-- TODO Commenté pour le moment en attendant de voir ce qui sera à afficher au final -->
    <!-- <div class="event-box-note">
        <div class="note-label">Note</div>
        <div class="note-content">Bla bla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla blabla bla bla</div>
    </div> -->

</div>